import { parseDaysSinceUpdate } from "./parse-days-since-update";

export interface DaysSinceUpdateResult {
  countDays: number;
  status: number;
  displayText: string;
}

export interface CalculateDaysSinceUpdateOptions {
  date?: string | Date;
  dateAcknowledge?: string | Date | null;
  prefix?: string;
  daysSinceUpdate?: string | number | null;
  treatAsToday?: boolean;
}

const buildResult = (
  countDays: number,
  prefix?: string,
): DaysSinceUpdateResult => {
  let status = 1;
  if (countDays > 30 && countDays <= 60) status = 2;
  else if (countDays > 60) status = 3;

  const displayText =
    countDays === 0
      ? "Hoje"
      : `${prefix ?? ""}${countDays} ${countDays === 1 ? "dia" : "dias"}`;

  return { countDays, status, displayText };
};

export const calculateDaysSinceUpdate = ({
  date,
  dateAcknowledge,
  prefix,
  daysSinceUpdate,
  treatAsToday,
}: CalculateDaysSinceUpdateOptions): DaysSinceUpdateResult => {
  if (treatAsToday) {
    return buildResult(0, prefix);
  }

  const parsedFromApi = parseDaysSinceUpdate(daysSinceUpdate);
  if (parsedFromApi !== null && parsedFromApi >= 0) {
    return buildResult(parsedFromApi, prefix);
  }

  if (date == null) {
    return buildResult(0, prefix);
  }

  const today = new Date();
  const dataUpdatedAt = new Date(date);
  const acknowledgeDate = dateAcknowledge ? new Date(dateAcknowledge) : null;

  const lastDay =
    acknowledgeDate && acknowledgeDate > dataUpdatedAt
      ? acknowledgeDate
      : dataUpdatedAt;

  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const lastDayStart = new Date(
    lastDay.getFullYear(),
    lastDay.getMonth(),
    lastDay.getDate(),
  );

  const oneDay = 24 * 60 * 60 * 1000;
  const diffInMs = todayStart.getTime() - lastDayStart.getTime();
  const countDays = Math.floor(diffInMs / oneDay);

  return buildResult(countDays, prefix);
};
